import { initializePage } from "@/pageUtils";
import { useAppStore } from "@/stores/app";
import { useAssets } from "./useAssets";
import { useFavicons } from "./useFavicons";

export const useBrandConfig = () => {
  const store = useAppStore();
  const { apply: applyFavicons } = useFavicons();
  const { brandAssets, favicons } = useAssets();
  const { appTexts } = useAppStore();

  async function initPage() {
    if (!store.brand) {
      await store.loadBrandData(store.insuranceCode);
    }
    initializePage(store.brand);
    applyFavicons();
  }

  const assetsComposable = {
    images: brandAssets.value,
    favicons: favicons.value,
    tutorialSteps: brandAssets.value.tutorial,
    appTexts: appTexts,
  };

  const pageComposable = {
    initialize: initPage,
  };

  return {
    assets: assetsComposable,
    page: pageComposable,
    appTexts: appTexts,
  };
};
